<div class="w-full h-full bg-gradient-to-br from-blue-600 via-blue-500 to-blue-400 relative overflow-hidden flex items-center justify-center">
    <!-- Background pattern -->
    <div class="absolute inset-0 z-0 ad-redirect-background"></div>

    <!-- Loading State -->
    <div class="text-center bg-white p-12 rounded-2xl shadow-2xl max-w-md w-full relative z-10" *ngIf="loading">
        <div class="mb-6">
            <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <p class="text-lg text-gray-600 font-medium">
            Autenticando con Active Directory...
        </p>
    </div>

    <!-- Error State -->
    <div class="text-center bg-white p-12 rounded-2xl shadow-2xl max-w-md w-full relative z-10" *ngIf="error">
        <div class="mb-6">
            <mat-icon class="text-6xl text-red-500">error</mat-icon>
        </div>
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">
            Error de Autenticación
        </h2>
        <p class="text-base text-gray-600 mb-8 leading-relaxed">
            {{ errorMessage }}
        </p>
        <button mat-raised-button color="primary" class="min-w-[150px] h-11 font-medium" (click)="retryAuthentication()">
            <mat-icon class="mr-2">refresh</mat-icon>
            Reintentar
        </button>
    </div>

    <!-- Success State -->
    <div class="text-center bg-white p-12 rounded-2xl shadow-2xl max-w-md w-full relative z-10" *ngIf="success">
        <div class="mb-6">
            <mat-icon class="text-6xl text-green-500">check_circle</mat-icon>
        </div>
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">
            Autenticación Exitosa
        </h2>
        <p class="text-base text-gray-600 mb-6 leading-relaxed">
            Redirigiendo al sistema...
        </p>
        <div class="mt-4">
            <mat-spinner [diameter]="40"></mat-spinner>
        </div>
    </div>
</div>